import React, { useState } from 'react';
import { Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';

import TransferTable from './TransferTable';
import { StyledTabs, TabsWrapper } from './TransferStyled';

const TAB_ALL = 'ALL';
const TAB_TICKET = 'TICKET';
const TAB_PASS = 'PASS';
const TAB_PRODUCT = 'PRODUCT';
const TAB_LOCKER = 'LOCKER';

const Transfer = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(TAB_ALL);

  const handleChangeTab = (_, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <div>
      {/* 기본 높이(40px 고정)가 탭보다 작아 아래 카드 테두리와 붙는다 — 내용 높이에 맞추고 간격을 둔다 */}
      <TabsWrapper sx={{ height: 'auto', marginBottom: '20px' }}>
        <StyledTabs
          value={selectedTab}
          onChange={handleChangeTab}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="transfer tabs">
          <Tab value={TAB_ALL} label={t('전체')} />
          <Tab value={TAB_TICKET} label={t('Ticket Transfer')} />
          <Tab value={TAB_PASS} label={t('Pass Transfer')} />
          <Tab value={TAB_PRODUCT} label={t('기간 상품')} />
          <Tab value={TAB_LOCKER} label={t('라커')} />
        </StyledTabs>
      </TabsWrapper>

      <TransferTable type={selectedTab} />
    </div>
  );
};

export default Transfer;
